'use es6';

import { Component } from 'react';
import Languages from '../constants/Languages';
import LanguageUtil from '../util/LanguageUtil';
import { getLocalizedUrl } from '../util/Urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class LanguageSwitchPopup extends Component {
  constructor(...args) {
    super(...args);
    this.renderCheck = language => {
      return LanguageUtil.getUserLanguage() === language ? /*#__PURE__*/_jsx("span", {
        className: "icon icon-check"
      }) : undefined;
    };
    this.renderLanguages = () => {
      return Object.keys(Languages).map((languageKey, index) => {
        const language = Languages[languageKey];
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsxs("a", {
            className: "language-switcher-link",
            href: getLocalizedUrl(languageKey),
            children: [this.renderCheck(languageKey), language]
          })
        }, index);
      });
    };
  }
  render() {
    const {
      props
    } = this;
    const ulClassNames = props.isOpen ? "open" : "";
    return /*#__PURE__*/_jsx("ul", {
      className: ulClassNames,
      children: this.renderLanguages()
    });
  }
}
export default LanguageSwitchPopup;